import React, { useState } from "react";
import PropTypes from "prop-types";
import { se } from "date-fns/locale";

/**
 * 3-D pill-style icon button.
 *
 * @param {React.ElementType} icon     React-icon component, e.g. FaEdit
 * @param {string}            variant  'primary' | 'success' | 'warning' | any CSS color/hex
 * @param {function}          onClick  click handler
 * @param {string}            title    tooltip text
 * @param {number}            size     icon font-size in px
 * @param {object}            style    extra inline styles
 * @param {string}            className extra classes
 */
export default function Icon({
  icon: Icon,
  variant = "primary",
  onClick,
  title = "",
  size = 16,
  style = {},
  className = ""
}) {
  const [hover, setHover] = useState(false);

  // Allow Bootstrap-style names or any CSS color value
  const COLORS = {
    primary: "#0d6efd",
    success: "#198754",
    warning: "#f0ad4e",
    secondary: "#6c757d",
    danger: "#dc3545",
    info: "#0dcaf0",
  };
  const bg = COLORS[variant] || variant;

  const baseShadow =
    "2px 2px 6px rgba(0,0,0,.2), inset -1px -1px 1px rgba(255,255,255,.2)";
  const hoverShadow =
    "3px 3px 8px rgba(0,0,0,.3), inset -1px -1px 1px rgba(255,255,255,.3)";

  return (
    <span
      role="button"
      title={title}
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      className={className}
      style={{
        cursor: "pointer",
        color: "#fff",
        backgroundColor: bg,
        padding: "6px 8px",
        borderRadius: "10px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: size,
        transition: "all .2s ease-in-out",
        transform: hover ? "translateY(-2px)" : "translateY(0)",
        boxShadow: hover ? hoverShadow : baseShadow,
        ...style
      }}
    >
      <Icon />
    </span>
  );
}

Icon.propTypes = {
  icon:       PropTypes.elementType.isRequired,
  variant:    PropTypes.string,
  onClick:    PropTypes.func,
  title:      PropTypes.string,
  size:       PropTypes.number,
  style:      PropTypes.object,
  className:  PropTypes.string
};
